const alfredReducer = function (state = { intent: [], questions: [], chart_array: {}, metric: [], alfred_question: '' }, action) {
    switch (action.type) {
        case "GET_ALFRED_QUESTIONS":
            return { ...state, intent: [...JSON.parse(action.payload.intent)], questions: [...action.payload.questions], chart_array: JSON.parse(action.payload.chart), metric: [...JSON.parse(action.payload.metric)] }
        case "GET_QUESTION_STATE":
            return { ...state }
        case "SET_QUESTION_STATE":
            return { ...state, alfred_question: action.payload.alfred_question }
        case "RESET_ALFRED_QUESTIONS":
            return { ...state, intent: [], questions: [], metric: [] }
        default:
            return state;
    }
}
export default alfredReducer;